import { render, staticRenderFns } from "./mystore.vue?vue&type=template&id=505ccd5c&scoped=true"
import script from "./mystore.vue?vue&type=script&lang=js"
export * from "./mystore.vue?vue&type=script&lang=js"
import style0 from "./mystore.vue?vue&type=style&index=0&id=505ccd5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ccd5c",
  null
  
)

export default component.exports